<template>
  <div class="laonlhfrmzx_fluid w_100">
    <div class="laonlhfrmzx">
     <div class="flex between">
     	<sec-title class="text_center" Text="合肥热门咨询"  :showmore = 'false'/>
     	<div class="tagtitle flex_start">
     	  <div>婚姻家庭</div>
     	  <div>交通事故</div>
     	  <div>劳动纠纷</div>
     	  <div>债权债务</div>
     	  <div>刑事辩护</div>
     	  <div>合同纠纷</div>
     	  <div>房产纠纷</div>
     	</div>
     </div>
      <div class="hfrmzx_cont between wrap">
        <div class="card_item" v-for="(item, index) in 4" :key="index">
          <div class="w flex_start">
            <img src="../../../assets/question/w.png" />
            {{
              `p2p投资，现起诉借款人和渠道商，做财产保全，可以申请法院给`
                | toEllipsisFilter(55)
            }}
          </div>
          <div class="d flex_start">
            <img src="../../../assets/question/d.png" />

            {{
              `可以申请调查令调取对方财产`
                | toEllipsisFilter(27)
            }}
          </div>
          <div class="t flex_end">
            <div class="tag"><span>2</span>位律师回复</div>
            <div class="tag">200人阅读</div>
            <div class="tag">2021-03-28</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import secTitle from "views/home/components/secTitle";
export default {
  components: {
    secTitle,
  },
};
</script>

<style lang="scss" scope>
.laonlhfrmzx_fluid {
  background-color: #f8f8f8;
  .laonlhfrmzx {
    width: 1200px;
    margin: 0 auto;
    padding: 50px 0;
    .tagtitle {
      // margin: 30px 0 10px;
      line-height: 20px;
      div {
        padding-right: 20px;
        color: #333333;
        border-right: 1px solid #333333;
        margin-right: 20px;
        font-size: 20px;
        &:last-child {
          border-right: none;
        }
      }
    }
    .hfrmzx_cont {
      .card_item {
        cursor: pointer;
        width: 582px;
        height: 170px;
        text-align: left;
        background: #ffffff;
        padding: 28px;
        margin-top: 25px;
        box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
        &:hover {
          .w {
            color: #0465ea;
          }
        }
        .w,
        .d {
          img {
            width: 32px;
            height: 32px;
            margin-right: 15px;
          }
        }
        .w {
          color: #333;
        }
        .d {
          margin-top: 15px;
          color: #666;
        }
        .t {
          font-size: 14px;
          margin-top: 14px;
          color: #999;
          .tag {
            margin-right: 4px;
            padding-right: 4px;
            line-height: 14px;
            border-right: 1px solid #999;
            span {
              color: #cc0101;
            }
            &:last-child {
              border-right: none;
            }
          }
        }
      }
    }
  }
}
</style>